import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { api } from '../utils/api';
import { CheckCircle } from 'lucide-react';
import { Button } from '../components/ui/button';

export const PaymentSuccess = () => {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');
  const { token } = useAuth();
  const navigate = useNavigate();
  const [status, setStatus] = useState('checking');
  const [attempts, setAttempts] = useState(0);

  useEffect(() => {
    if (sessionId && token) {
      pollPaymentStatus();
    }
  }, [sessionId, token]);

  const pollPaymentStatus = async () => {
    const maxAttempts = 5;
    
    if (attempts >= maxAttempts) {
      setStatus('timeout');
      return;
    }

    try {
      const data = await api.get(`/api/payments/status/${sessionId}`, token);
      
      if (data.payment_status === 'paid') {
        setStatus('success');
      } else if (data.status === 'expired') {
        setStatus('expired');
      } else {
        setAttempts(prev => prev + 1);
        setTimeout(pollPaymentStatus, 2000);
      }
    } catch (error) {
      setStatus('error');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background" data-testid="payment-success-page">
      <div className="max-w-md w-full bg-white p-8 rounded-xl shadow-lg text-center">
        {status === 'checking' && (
          <>
            <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-primary mx-auto mb-4"></div>
            <h2 className="text-2xl font-display font-bold text-primary mb-2">
              Processando Pagamento
            </h2>
            <p className="text-text-secondary">
              Aguarde enquanto confirmamos seu pagamento...
            </p>
          </>
        )}

        {status === 'success' && (
          <>
            <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <CheckCircle className="h-10 w-10 text-green-600" />
            </div>
            <h2 className="text-2xl font-display font-bold text-primary mb-2">
              Pagamento Confirmado!
            </h2>
            <p className="text-text-secondary mb-6">
              Sua reserva foi confirmada com sucesso. Enviamos um email com os detalhes.
            </p>
            <div className="space-y-3">
              <Button
                className="w-full bg-primary hover:bg-primary/90 rounded-full"
                onClick={() => navigate('/my-bookings')}
                data-testid="view-bookings-button"
              >
                Ver Minhas Reservas
              </Button>
              <Button
                variant="outline"
                className="w-full rounded-full"
                onClick={() => navigate('/')}
              >
                Voltar ao Início
              </Button>
            </div>
          </>
        )}

        {(status === 'error' || status === 'timeout' || status === 'expired') && (
          <>
            <h2 className="text-2xl font-display font-bold text-red-600 mb-2">
              Erro no Pagamento
            </h2>
            <p className="text-text-secondary mb-6">
              Houve um problema ao processar seu pagamento. Por favor, tente novamente.
            </p>
            <Button
              className="w-full bg-primary hover:bg-primary/90 rounded-full"
              onClick={() => navigate('/rooms')}
            >
              Tentar Novamente
            </Button>
          </>
        )}
      </div>
    </div>
  );
};
